import Source from 'ol/source/Source.js';
import Layer from 'ol/layer/Layer.js';
import {toDegrees} from 'ol/math.js';
import {toLonLat} from 'ol/proj.js';

import maplibregl from 'maplibre-gl';
// import type {FrameState} from 'ol/Map.js';
// import type {Options as LayerOptions} from 'ol/layer/Layer.js';

// export type MapLibreLayerOptions = LayerOptions & {
//   maplibreOptions: Omit<maplibregl.MapOptions, 'container'>;
// };

class MapLibreSource extends Source {
  constructor(options) {
    super(options);
  }
}

export default class MapLibreLayer extends Layer {
  // maplibreMap: maplibregl.Map;
  maplibreMap;
  source;
  layersLoaded;

  // constructor(options: MapLibreLayerOptions) {
  constructor(options) {
    const {maplibreOptions, ...baseOptions} = options;

    super(baseOptions);
    this.source = new MapLibreSource(baseOptions);

    const container = document.createElement('div');
    container.style.position = 'absolute';
    container.style.width = '100%';
    container.style.height = '100%';

    this.maplibreMap = new maplibregl.Map(
      Object.assign({}, maplibreOptions, {
        container: container,
        attributionControl: false,
        interactive: false,
        trackResize: false,
      }),
    );
    // this.initLayersLoaded();
    // this.source.loading = this.getLoadingSource();
    // this.maplibreMap.on('render', () => {
    // this.maplibreMap.on('load', () => {
    this.maplibreMap.on('idle', () => {
      // if (!!this.maplibreMap._loaded) {
      //   this.source.loading = false;
      // }
      this.source.loading = false;
      // const mapLoaded = this.maplibreMap.loaded();
      // if (!!mapLoaded || this.maplibreMap._loaded) {
      // if (!!mapLoaded) {
      //   this.source.loading = false;
      // }
      this.changed();
    });
    // this.maplibreMap.on('load', () => {
    //   this.source.loading = true;
    //   this.changed();
    // });
    // this.maplibreMap.on('load', () => {
    //   this.initLayersLoaded();
    // });

    this.applyOpacity_();
  }

  initLayersLoaded() {
    this.layersLoaded = [];
    const style = this.maplibreMap.getStyle();
    const layers = !!style?.layers ? style.layers : [];
    for (const lstyle of layers) {
      if (!!lstyle) {
        const l = this.maplibreMap.getLayer(lstyle.id);
        if (!!l) {
          this.layersLoaded[l.id] = {loaded: false};
          l.on('load', () => {
            this.setLoadedLayer(l.id);
          });
          l.on('loading', () => {
            this.setLoadingLayer(l.id);
          });
        }
      }
    }
  }
  getLoadingSource() {
    if (!this.layersLoaded?.length) {
      return true;
    }
    let allLoaded = true;
    for (const lState of this.layersLoaded) {
      allLoaded = allLoaded && lState.loaded;
    }
    if (allLoaded) {
      return false;
    }
    return true;
  }
  setLoadedLayer(lId) {
    this.layersLoaded[lId] = {id: lId, loaded: true};
    this.source.loading = this.getLoadingSource();
  }
  setLoadingLayer(lId) {
    this.layersLoaded[lId] = {id: lId, loaded: false};
    this.source.loading = this.getLoadingSource();
  }
  // override disposeInternal() {
  disposeInternal() {
    this.maplibreMap.remove();
    super.disposeInternal();
  }

  // override setOpacity(opacity: number) {
  setOpacity(opacity) {
    super.setOpacity(opacity);
    this.applyOpacity_();
  }

  // private applyOpacity_() {
  applyOpacity_() {
    const canvas = this.maplibreMap.getCanvas();
    const opacity = this.getOpacity().toString();
    if (opacity !== canvas.style.opacity) {
      canvas.style.opacity = opacity;
    }
  }

  // override render(frameState: FrameState): HTMLElement {
  render(frameState) {
    const viewState = frameState.viewState;
    this.source.loading = true;

    // adjust view parameters in maplibre
    this.maplibreMap.jumpTo({
      // center: toLonLat(viewState.center) as [number, number],
      center: toLonLat(viewState.center),
      zoom: viewState.zoom - 1,
      bearing: toDegrees(-viewState.rotation),
    });

    const maplibreCanvas = this.maplibreMap.getCanvas();
    if (!maplibreCanvas.isConnected) {
      // The canvas is not connected to the DOM, request a map rendering at the next animation frame
      // to set the canvas size.
      // this.getMapInternal()!.render();
      this.getMapInternal().render();
    } else if (!sameSize(maplibreCanvas, frameState)) {
      this.maplibreMap.resize();
    }

    this.maplibreMap.redraw();

    return this.maplibreMap.getContainer();
  }
}

// function sameSize(canvas: HTMLCanvasElement, frameState: FrameState): boolean {
function sameSize(canvas, frameState) {
  return (
    canvas.width === Math.floor(frameState.size[0] * frameState.pixelRatio) &&
    canvas.height === Math.floor(frameState.size[1] * frameState.pixelRatio)
  );
}
